goog.provide('el8.shared.util.renderGrowthChart');

goog.require('el8.service.tooltip');
/**
 * Given the data from the PatientGrowthChart or PrintPatientGrowthChartViews
 * and a DOM element $graph, this file uses Flot to plot a growth chart
 *
 * isPrintout is used to tweak some details for the print version
 */
el8.shared.util.renderGrowthChart = function(data, $graph, isPrintout) {

    var IPHONE_PORTRAIT_BOUND = 400;
    var IPHONE_ANY_BOUND = 500;

    var refInfo = data['refInfo'];
    var ptData = data['patientData'];

    var xInterval = refInfo['xInterval'];
    var yInterval = refInfo['yInterval'];

    var legendContainer = $(".growthChartLegend")

    var PALETTE = [
        '#E41A1C',
        '#377EB8',
        '#4DAF4A',
        '#984EA3',
        '#FF7F00',
        '#DECA16',
        '#A65628',
        '#F781BF',
        '#999999',
    ];

    var plotData = [];
    var plotOpts = {
        yaxis: {
            min: refInfo['yMin'],
            max: refInfo['yMax'],
            tickSize: 1,
            labelWidth: 50,
            tickFormatter: function(v) {
                return (v % yInterval === 0) ? v + " "+refInfo['yUnits'] : "";
            }
        },
        xaxis: {
            min: refInfo['xMin'],
            max: refInfo['xMax'],
            tickSize: 1,
            tickFormatter: function(v) {
                // in iPhone portrait, this x-axis is too cramped, so we'll skip every other label
                var interval = ($graph.width() < IPHONE_PORTRAIT_BOUND) ? xInterval*2 : xInterval;
                return (v % interval === 0) ? v + " "+refInfo['xUnits'] : "";
            }
        },
        grid: {
            markings: function(axes) {
                var markings = [];
                for (var x = Math.floor(axes.xaxis.min)+xInterval; x<axes.xaxis.max; x+=xInterval) {
                    markings.push({xaxis: {from: x, to: x}, lineWidth: 0.5, color: '#777788'});
                }
                for (var y = Math.floor(axes.yaxis.min)+yInterval; y<axes.yaxis.max; y+=yInterval) {
                    markings.push({yaxis: {from: y, to: y}, lineWidth: 0.5, color: '#777788'});
                }
                return markings;
            },
            margin: {
                right: 80
            }
        },
        legend: {
            container: legendContainer
        }
    };

    // extra dark lines at key percentiles (0%, 50%, and 97/98%)
    var _getLineWidth = function(lineIndex) {
        if (lineIndex === 0 || lineIndex === 4 || lineIndex === 8) {
            return (isPrintout) ? 2 : 1.4; // the bold lines need to be extra bold to look different on the printout
        }
        return 0.7;
    };



    // Set up the reference lines
    for (var i=0; i<refInfo['plotData'].length; i++) {
        plotData.push({
            color: PALETTE[i % PALETTE.length],
            data: refInfo['plotData'][i]['data'],
            label: refInfo['plotData'][i]['label'],
            shadowSize: 0,
            lines: {
                lineWidth: _getLineWidth(i),
                show: true
            }
        });
    }

    // Set up the patient data points

    var ptCoords = []
    $.each(ptData, function(i, item) {
        ptCoords.push([item.age, item.value]);
    });

    var dotColor = (isPrintout) ? '#000' : '#438CC9';
    var screenRadius = ($graph.width() < IPHONE_ANY_BOUND) ? 1 : 2;
    plotData.push({
        color: dotColor,
        data: ptCoords,
        shadowSize: 0,
        hoverable: true,
        points: {
            show: true,
            radius: (isPrintout) ? 3 : screenRadius,
            fillColor: dotColor
        }
    });

    $graph.removeClass('dataLoading');
    var p = $.plot($graph, plotData, plotOpts);
    var pData = p.getData();

    // last array is the patient's data as opposed to reference lines
    var patientDataPoints = pData[pData.length-1].data;
    $.each(patientDataPoints, function(i, el){

        // Data is in recent-first order
        var isLast = i == 0;

        var o = p.pointOffset({x: el[0], y: el[1]});
        if (isLast) {
            $('<div class="el8GrowthChartDataLabel">' + el[1] + ' ' + refInfo['yUnits'] + '</div>').css({
                position: 'absolute',
                left: o.left,
                top: o.top - 16
            }).appendTo(p.getPlaceholder());
        }

        var anchor = $('<div class="el8GrowthChartDataAnchor"> </div>').css({
            position: 'absolute',
            left: o.left - 5,
            top: o.top - 5
        }).appendTo(p.getPlaceholder());

        el8.service.tooltip.create({
            anchor: anchor,
            text: ptData[i].value + ' ' + refInfo['yUnits'] + ' ' + ptData[i].when
        });
    });
};